<template>
  <Modal @close="$emit('close')" :title="title">
    <div slot="body">
      <div class="container">
        <div class="row">
          <div
            class="col-md-6 text-center custom-scroll"
            id="students-table"
            v-if="showDetails"
          >
            <table class="table elevation-1">
              <thead class="text-logo">
                <tr>
                  <th>Estudiantes</th>
                </tr>
              </thead>
              <tbody class="text-primary pointer">
                <template v-for="(item, i) in studentsData">
                  <tr
                    :key="i"
                    @click="selectedItem = i"
                    :class="{ 'text-logo': i == selectedItem }"
                  >
                    <td>{{ item.firstname1 }} {{ item.lastname }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div
            class="mx-auto text-center"
            :class="{ 'col-md-6': showDetails, 'col-md-8': !showDetails }"
          >
            <template v-if="!studentsData || studentsData.length <= 0">
              <div class="row">
                <div class="col text-center">
                  {{ $t("noDataToDisplay") }}
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="showDetails">
                <span class="h2">
                  {{ studentsData[selectedItem].firstname1 }}
                  {{ studentsData[selectedItem].lastname }}
                </span>
              </template>
              <Legend v-if="data" class="pl-2 pt-4" />
              <DoughnutChartContainer
                v-if="data"
                :key="showDetails ? selectedItem : ''"
                :data="showDetails ? studentsData[selectedItem] : data"
                :case="'libros'"
                :legendDisplay="false"
                :isTotalPercentages="!showDetails"
              />
              <div class="row">
                <div class="col text-center">
                  <button
                    class="button"
                    :disabled="!studentsData || studentsData.length <= 0"
                    :class="{ logo: showDetails, primary: !showDetails }"
                    @click="showDetails = !showDetails"
                  >
                    {{ showDetails ? "Ocultar detalles" : "Ver detalles" }}
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import DoughnutChartContainer from "@/components/generalResults/DoughnutChartContainer";
import Modal from "@/components/Modal";
import Legend from "@/components/generalResults/Legend.vue";

export default {
  name: "ReadingComprehension",
  components: {
    Modal,
    DoughnutChartContainer,
    Legend,
  },
  props: {
    assignment: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapState(["dataUrl", "reports"]),
  },
  data() {
    return {
      title: "Resultados de Comprensión Lectora",
      selectedItem: 0,
      data: null,
      studentsData: null,
      showDetails: false,
    };
  },
  mounted() {
    this.data = this.assignment.mdReportInfoDTO;
    if (this.assignment.mdReportInfoDTO)
      this.studentsData = this.assignment.mdReportInfoDTO.detalles;
  },
};
</script>

<style lang="scss">
#students-table {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
